import { render } from "./image_modal.vue?vue&type=template&id=627dbb42&scoped=true"
import script from "./image_modal.vue?vue&type=script&lang=js"
export * from "./image_modal.vue?vue&type=script&lang=js"

import "./image_modal.vue?vue&type=style&index=0&id=627dbb42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627dbb42"]])

export default __exports__